import React from 'react';

const Backdrop = props => <div className="pda-backdrop">{props.children}</div>;

export default Backdrop;
